import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { handlesTypeFilter } from 'rangeConfig/shared/filters/configFilters';
import { colorFilter } from 'rangeConfig/shared/filters/configFilters';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import handlesProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import showHandlesDrillTemplateSheet from 'rangeConfig/shared/behaviors/showHandlesDrillTemplateSheet';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { getNoFramesInSceneErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { CoreApi } from '@inter-ikea-storageone/range';
import {
  sortByName,
  sortByPriceAscending,
  sortByPriceDescending
} from 'rangeConfig/shared/sorting/sortingConfigs';

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'handles-sort-filter-widget',
      component: ProductSortFilterWidget
    },
    {
      id: 'handles-product-list',
      component: withProducts(ProductList, handlesProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'handels-product-swiper',
      component: withProducts(ProductSwiper, handlesProductListConfig),
      title: 'storageone.productListHandlesTitle'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListHandlesTitle',
  behaviors: {
    productGroupEntered: [showDoors],
    productGroupExited: [showHandlesDrillTemplateSheet]
  },
  sorting: [sortByName, sortByPriceAscending, sortByPriceDescending],
  filters: [handlesTypeFilter, colorFilter],
  widgets: widgets[platform]
};

export default mainMenu;
